import { getBiAreaAndPlatform } from '@wix/wix-chatbot-common/browser';

import { TRootState } from '../../common/reducers';
import { renderModel } from '../../util/renderModel';
import { selectBiData } from '../selectors';
import { getRuntimeDataForBi } from './getRuntimeDataForBi';

interface SharedBiFields {
  context_url?: string;
  context_area?: string;
  context_platform?: string;
  self_service_session_id?: string;
  chatbot_conversation_id?: string;
  context_msid?: string;
  widget_language?: string;
}

const getSharedBiFields = (
  contextUrl?: string,
  sessionId?: string,
  chatbotConversationId?: string,
  contextMsid?: string,
): SharedBiFields => {
  let contextArea = '';
  let contextPlatform = '';

  if (contextUrl) {
    const biData = getBiAreaAndPlatform(contextUrl);
    contextArea = biData.contextArea;
    contextPlatform = biData.contextPlatform;
  }

  return {
    context_url: contextUrl,
    context_area: contextArea,
    context_platform: contextPlatform,
    self_service_session_id: sessionId,
    chatbot_conversation_id: chatbotConversationId,
    context_msid: contextMsid,
    widget_language: renderModel.getLocale(),
  };
};

export const getSharedBiFieldsFromState = async (state: TRootState): Promise<SharedBiFields> => {
  const { sessionId, contextBi } = await getRuntimeDataForBi(state);
  const biData = selectBiData(state);
  // Parent page URL, not iframe URL
  const contextUrl = contextBi?.context_parenturl;

  return getSharedBiFields(contextUrl, sessionId, biData.conversationId, contextBi?.context_msid);
};
